export default __webpack_public_path__ + "static/media/backup.81e5e3d7.png";